import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ellipsis',
    standalone: true
})
export class EllipsisPipe implements PipeTransform {

    transform(value: string, limit: number): any {
        const length = value.length;
        const prefix = length > limit ? '…' : '';

        return value.substr(0, limit) + prefix;
    }

}
